import { Box, Button, IconButton, MobileStepper } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers';
import App from 'AppInterface/App';
import { onShare, refToDataUrl, ShareBottom, ShareTop } from 'components/common/ShareControls';
import DialogPage, { DialogContext } from 'components/pages/DialogPage';
import TextContent from 'components/TextContent';
import { edgeToEdgeBuffer, MainRhyme4 } from 'config';
import { Icons } from 'config/icons';
import { getContentStorageUrl, isAdmin, isEdgeToEdgeEnabled, toDataUrl } from 'helpers';
import moment, { Moment } from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { getQuotesByDate } from 'store/data/quotes/selectors';
import { toggleBottomDrawer } from 'store/temp/actions';
import { ApplicationState, ContentType, Quote } from 'types';
import { bottom_data, top_data } from './data_uris';
// import QRCodeStyling from 'qr-code-styling';

const classes = {
	quote: {
		textAlign: 'center' as 'center',
		textTransform: 'none' as 'none',
		fontWeight: 'normal' as 'normal',
		lineHeight: 1.7,
		padding: '1px',
	},
	borderImg: {
		height: '3.5rem',
	},
	quoteDiv: (theme: Theme) => ({
		padding: theme.spacing(2),
		backgroundColor: 'white',
		textAlign: 'center',
	}),
	pickerbar: {
		width: '100%',
		marginRight: '-12px',
		textAlign: 'center' as 'center',
	},
	picker: {
		transform: 'translateY(6px)',
		minWidth: 200,

		'& .MuiInput-underline::after': {
			transform: 'scaleX(0) !important',
			borderWidth: 1,
		},
		'& input': {
			textAlign: 'center' as 'center',
			fontSize: '0.9em',
		},
		'& .MuiIconButton-root': {
			visibility: 'visible',
		},
	},
	plainAppBar: (theme: Theme) => ({
		borderTop: `8px solid ${theme.palette.primary.main}`,
		borderBottom: `1px solid lightgrey`,
		backgroundColor: 'white',
		// boxShadow: 'none',
		color: 'inherit',

		'& .MuiIconButton-root': {
			color: 'rgba(0, 0, 0, 0.54)',
		},

		'& .MuiToolbar-root': {
			minHeight: 56,
			paddingTop: 0,
		},
	}),
	stepper: (theme: Theme) => ({
		fontSize: theme.typography.body2.fontSize,
		maxWidth: 400,
		flexGrow: 1,
		background: 'white',
		margin: 'auto',
	}),
};

let minQuoteDate = moment('2017-05-26');

interface QuoteProps {
	quotes: { [date: string]: Quote };
	quote?: Quote;
	locale: string;
	toggleDrawer: (content?: any, open?: boolean, styles?: string) => void;
	isModal: boolean;
	showAll: boolean;
	appBuildCode: number;
	appEnv: string;
	forShare?: boolean;
	onImgComplete?: (dataUrl: any) => void;
}

interface QuoteContentProps {
	locale: string;
	hideTopFloral?: boolean;
	text: string;
}

// const qrCode = new QRCodeStyling({
// 	width: 300,
// 	height: 300,
// 	data: 'https://ssdn.app/shri-anandpur-satsang',
// 	image: getContentStorageUrl(ContentType.PKP, 'webapp/app_icon.png'),
// 	dotsOptions: {
// 		color: '#038b00', // '#4267b2',
// 		type: 'square',
// 	},
// 	imageOptions: {
// 		crossOrigin: 'anonymous',
// 		// imageSize: 0.3,
// 		margin: 20,
// 	},
// 	qrOptions: {
// 		errorCorrectionLevel: 'H',
// 	},
// });

class Content extends React.Component<QuoteContentProps> {
	render() {
		let { locale, text, hideTopFloral } = this.props;

		return (
			<Box sx={classes.quoteDiv}>
				{!hideTopFloral && <Box component="img" sx={classes.borderImg} src={top_data} />}
				<TextContent locale={locale} alignRhymes={true} useFontSize={true}>
					<Box sx={classes.quote} dangerouslySetInnerHTML={{ __html: text }}></Box>
				</TextContent>
				<Box component="img" sx={classes.borderImg} src={bottom_data} />
			</Box>
		);
	}
}

export const QuoteContent = Content;

class Component extends React.Component<QuoteProps, { date: Moment; forShare: boolean; isPlaying: boolean }> {
	private quoteRef = React.createRef<any>();
	private audioRef = React.createRef<any>();

	constructor(props) {
		super(props);

		this.state = {
			date: this.props.quote ? moment(this.props.quote.forDate) : moment(),
			forShare: this.props.forShare ?? false,
			isPlaying: false,
		};
	}

	componentDidMount = async () => {
		// console.log('app_icon', await toDataUrl(getContentStorageUrl(ContentType.PKP, 'webapp/app_icon_200.png')));
		// console.log('qr_code', await toDataUrl(getContentStorageUrl(ContentType.PKP, 'webapp/qr_ssdn_app.jpeg')));
		// console.log('top', await toDataUrl(getWebAppAssetPath('bg/dark/heading-bg-top.png')));
		// console.log('bottom', await toDataUrl(getWebAppAssetPath('bg/dark/heading-bg-bottom.png')));

		if (this.state.forShare) {
			let dataUrl = await refToDataUrl(this.quoteRef);

			if (this.props.onImgComplete) {
				this.props.onImgComplete(dataUrl);
			}
		}
	};

	render() {
		let { quotes, locale, isModal, showAll, appBuildCode } = this.props;
		let quote = this.props.quote ?? quotes[this.state.date.format('YYYY-MM-DD')];

		let text;
		if (quote) {
			text = quote.text[locale] || quote.text.hi || quote.text.en;
		} else {
			text = MainRhyme4;
		}

		let quoteContent = <QuoteContent locale={locale} text={text} hideTopFloral={quote?.hideTopFloral ?? false} />;

		let maxDate = new Date();
		if (showAll) {
			maxDate = new Date(Object.keys(quotes).sort((a, b) => (a < b ? 1 : -1))[0]);
		}
		maxDate = maxDate >= new Date() ? maxDate : new Date();

		let picker = (
			<Box sx={classes.pickerbar}>
				<DatePicker
					key={this.state.date.format('YYYY-MM-DD')}
					sx={classes.picker}
					minDate={minQuoteDate}
					maxDate={moment(maxDate)}
					value={this.state.date}
					openTo="year"
					format="ddd, Do MMM, YYYY"
					views={['year', 'month', 'day']}
					// disableOpenPicker={true}
					slotProps={{ textField: { variant: 'standard' } }}
					shouldDisableDate={(date: Moment) => {
						return !quotes[date.format('YYYY-MM-DD')];
					}}
					onAccept={(date: Moment | null) => {
						if (date) {
							this.setState({
								date: date,
								isPlaying: false,
							});
						}
					}}
				/>

				<IconButton
					style={{
						float: 'right',
						visibility: appBuildCode > 45 ? 'visible' : 'hidden',
					}}
					onClick={async () => {
						let shareLink = quote[`${locale}ShareLink`];
						await onShare(
							this.setState.bind(this),
							this.quoteRef,
							'Shri Anandpur Satsang, Quote - ' + this.state.date.format('dddd, Do MMM, YYYY'),
							shareLink ? getContentStorageUrl(ContentType.Quote, shareLink) : undefined
						);
					}}
					size="large"
				>
					{Icons.Share}
				</IconButton>
			</Box>
		);

		let currentIndex = this.state.date.diff(minQuoteDate, 'days');
		let totalDates = moment(maxDate).diff(minQuoteDate, 'days') + 1;

		let mediaUri = quote ? (locale === 'hi' ? quote['mediaUriHi'] : quote['mediaUriEn']) : undefined;
		let audioSrc = getContentStorageUrl(ContentType.Quote, '') + mediaUri;

		return (
			<DialogPage
				appBarSx={classes.plainAppBar}
				dialogSx={isEdgeToEdgeEnabled() ? { paddingTop: edgeToEdgeBuffer / 8 } : {}}
				extraAppBarElement={picker}
				showAppBar={!this.state.forShare}
				title=""
				transition={true}
				drawerType={true}
				goBackOnClose={isModal}
				goBackTo="/"
				style={{ paddingBottom: 0 }}
				disableBackdropClick={true}
				actionButtons={
					!this.state.forShare && (
						<MobileStepper
							variant="text"
							steps={totalDates}
							position="static"
							activeStep={currentIndex}
							sx={classes.stepper}
							nextButton={
								<Button
									size="small"
									onClick={async () => {
										this.setState({ date: this.state.date.add(1, 'day'), isPlaying: false });
									}}
									disabled={currentIndex >= totalDates - 1}
									color="inherit"
								>
									Next
									{Icons.KeyRightArrow}
								</Button>
							}
							backButton={
								<Button
									size="small"
									onClick={async () => {
										this.setState({ date: this.state.date.subtract(1, 'day'), isPlaying: false });
									}}
									disabled={currentIndex <= 0}
									color="inherit"
								>
									{Icons.KeyLeftArrow}
									Back
								</Button>
							}
						/>
					)
				}
			>
				<Box ref={this.quoteRef} sx={this.state.forShare ? { minWidth: 480 } : {}}>
					{this.state.forShare && <ShareTop subtitle={this.state.date.format('ddd, Do MMM, YYYY')} />}
					{quoteContent}
					{!this.state.forShare && mediaUri?.length ? (
						<Box key={quote.id}>
							<audio
								style={{ display: 'none' }}
								ref={this.audioRef}
								onEnded={() => {
									this.setState({ isPlaying: false });
								}}
								onPause={() => {
									this.setState({ isPlaying: false });
								}}
								preload="auto"
								loop={false}
								key={'audio-' + Math.random() + quote?.id}
								src={audioSrc}
							></audio>
							<Button
								size="small"
								variant="contained"
								sx={{ margin: '-6px 16px 12px auto', display: 'flex', borderRadius: '20px', padding: '4px 16px 4px 10px' }}
								onClick={() => {
									if (this.state.isPlaying) {
										this.audioRef.current?.pause();
									} else {
										this.setState({ isPlaying: true }, () => {
											this.audioRef.current?.play();
										});
									}
									// App.playMedia(
									// 	quote.id,
									// 	audioSrc,
									// 	getAudioFilenameFromSrc(mediaUri),
									// 	'Quote ' + quote.forDate,
									// 	false,
									// 	true,
									// 	0,
									// 	'Quote',
									// 	quote.forDate
									// );
								}}
							>
								{this.state.isPlaying ? Icons.Pause : Icons.Play} &nbsp; Listen
							</Button>
						</Box>
					) : null}
					{this.state.forShare && <ShareBottom locale={locale} />}
				</Box>
			</DialogPage>
		);
	}
}

function mapStateToProps(state: ApplicationState, props: { id?: string; isModal: boolean; quote?: Quote; lang?: string }) {
	let quotes = getQuotesByDate(state);
	let showAll =
		isAdmin(state.userState.userStore.user, state.userState.userStore.userData) &&
		state.userState.userStore.userData?.settings &&
		state.userState.userStore.userData?.settings['admin.records'];

	let quote = props.quote ?? (props.id ? state.dataState.quotes.byId[props.id] : undefined);

	return {
		quotes,
		quote,
		locale: props.lang ?? state.uxState.locale,
		showAll,
		appBuildCode: state.uxState.appParams.appBuildCode,
		appEnv: state.uxState.appParams.appEnv,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		toggleDrawer: (content?: any, open?: boolean, styles?: string) => {
			dispatch(toggleBottomDrawer(content, open, styles));
		},
	};
}

Component.contextType = DialogContext;

export const QuoteControl = connect(mapStateToProps, mapDispatchToProps)(Component);
